import React from 'react';
import { SkeletonSquare } from '@fiverr-private/feedback';
import SafeComponent from '../../shared/SafeComponent';
import { VARIANTS } from '../../utils/types/variants';
import useProPackagesBannerExperiment from '../../hooks/useProPackagesBannerExperiment';
import ProPackagesBannerB from './ProPackagesBannerB';
import ProPackagesBannerA from './ProPackagesBannerA';

interface FiverrBusinessProps {
    inProPackagesBanner?: boolean;
}

const FiverrBusiness = ({ inProPackagesBanner = false }: FiverrBusinessProps) => {
    const { experimentVariant, showBanner, observableRef } = useProPackagesBannerExperiment(inProPackagesBanner);

    return (
        <div ref={observableRef}>
            {showBanner ? (
                <ProPackagesBanner variant={experimentVariant} />
            ) : (
                <SkeletonSquare
                    dataTestId="fiverr-business-skeleton"
                    width="100%"
                    borderRadius="2xl"
                    height={{
                        default: '690px',
                        sm: '570px',
                        md: '540px',
                        lg: '660px',
                        xl: '630px',
                    }}
                />
            )}
        </div>
    );
};

const ProPackagesBanner = ({ variant }: { variant: number | null }) => {
    if (variant === VARIANTS.B) {
        return <ProPackagesBannerB />;
    }

    return <ProPackagesBannerA />;
};

export { FiverrBusiness };
export default SafeComponent(FiverrBusiness);
